import { useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  getCrmSettingsMatrix,
  getUpdateCrmMatrixSettings,
} from './MatrixCrmSettings.service';

import { CrmMatrixSettingsUpdate } from './MatrixCrmSettings.types';
import { notification } from 'antd';

export function useCrmMatrixSettings() {
  const query = useQuery(
    ['matrix-crm-settings'],
    () => getCrmSettingsMatrix(),
    {},
  );

  useServiceError(query.error);

  return query;
}

export function useCrmMatrixSettingsUpdate() {
  const query = useMutation(
    (obj: CrmMatrixSettingsUpdate) => getUpdateCrmMatrixSettings(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Configurações do CRM foram salvas com sucesso!',
        });
      },
    },
  );

  useServiceError(query.error);

  return query;
}
